// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiResultSearchRequest {
    static getAttributeTypeMap() {
        return MedicalBiResultSearchRequest.attributeTypeMap;
    }
}
MedicalBiResultSearchRequest.discriminator = undefined;
MedicalBiResultSearchRequest.additionalProperties = false;
MedicalBiResultSearchRequest.attributeTypeMap = [
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "number"
    },
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalBiResultSearchRequest.js.map